function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.312,
    height: 16.5,
    viewBox: "0 0 13.312 16.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "copy (5)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 15376"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 54670",
    d: "M57.353 85.4h-7.438a1.266 1.266 0 0 0-1.265 1.265v10.672a1.266 1.266 0 0 0 1.265 1.263h7.438a1.266 1.266 0 0 0 1.265-1.265v-10.67a1.27 1.27 0 0 0-1.265-1.265zm.377 11.934a.38.38 0 0 1-.38.38h-7.438a.38.38 0 0 1-.38-.38V86.665a.38.38 0 0 1 .38-.38h7.438a.38.38 0 0 1 .38.38z",
    transform: "translate(-48.4 -82.352)",
    style: {
      fill: "#2973f0",
      stroke: "#2973f0",
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 54671",
    d: "M144.153 0h-7.438a1.266 1.266 0 0 0-1.265 1.265.442.442 0 0 0 .885 0 .38.38 0 0 1 .38-.38h7.438a.38.38 0 0 1 .38.38v10.672a.38.38 0 0 1-.38.38.442.442 0 1 0 0 .885 1.266 1.266 0 0 0 1.265-1.265V1.265A1.266 1.266 0 0 0 144.153 0z",
    transform: "translate(-132.356 .25)",
    style: {
      fill: "#2973f0",
      stroke: "#2973f0",
      strokeWidth: ".5px"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.443b5f084254c5f1cc0bdc164902d937.svg";
export { ForwardRef as ReactComponent };